module.exports = __webpack_public_path__ + "application/templates/default/inner/add-processes/add-processes.template.html";